// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/App.css */

/* Global Stiller */
body {
  margin: 0;
  font-family: 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  scroll-behavior: smooth;
}

* {
  box-sizing: border-box;
}

/* Mevcut Stiller */
.App {
  text-align: center;
}

/* Navbar Logo */
.navbar-brand .logo {
  height: 40px;
  width: auto;
  margin-right: 10px;
}

/* Navbar */
.navbar {
  padding: 10px 20px;
}

/* Navbar Dil Değişim Butonu */
.navbar .nav-link.language-toggle {
  font-weight: bold;
  color: #00c4ff !important;
}

.navbar .nav-link.language-toggle:hover {
  color: #ffffff !important;
}

/* Hero Section */
.hero-section {
  min-height: 100vh;
  background: linear-gradient(to right, #007bff, #00c4ff);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.hero-section h1.display-4 {
  font-weight: bold;
  font-size: 2.5rem;
}

.hero-section .lead {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.hero-section p {
  font-size: 1rem;
}

/* Features Section */
.features-section {
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.features-section h2 {
  font-size: 2rem;
  margin-bottom: 30px;
}

.features-section .feature-card {
  border: none;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.features-section .feature-card:hover {
  transform: translateY(-5px);
}

.features-section .card-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.features-section .card-text {
  font-size: 0.9rem;
  color: #666;
}

.feature-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 15px auto;
  display: block;
}

/* Contact Section */
.contact-section {
  min-height: 100vh;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: left;
}

.contact-section h2 {
  font-size: 2rem;
  margin-bottom: 30px;
}

/* Form Etiketlerini Sağa Hizala */
.form-label-custom {
  width: 100px;
  text-align: right;
  margin-right: 15px;
}

.contact-section .form-group {
  display: flex;
  align-items: center;
}

.contact-section .form-group textarea {
  align-self: flex-start;
}

/* Footer */
footer {
  background-color: #1a1a1a;
  color: white;
  padding: 30px 20px;
}

footer p {
  margin: 5px 0;
  font-size: 0.9rem;
}

footer a {
  color: #00c4ff;
  text-decoration: none;
}

footer a:hover {
  text-decoration: underline;
}

/* Mobil Uyumluluk için Media Queries */
@media (max-width: 768px) {
  .hero-section h1.display-4 {
    font-size: 2rem;
  }

  .hero-section .lead {
    font-size: 1rem;
  }

  .hero-section p {
    font-size: 0.9rem;
  }

  .hero-section .btn {
    font-size: 0.9rem;
    padding: 8px 16px;
  }

  .features-section {
    min-height: 100vh;
    padding: 40px 20px;
  }

  .features-section h2 {
    font-size: 1.8rem;
  }

  .features-section .row {
    flex-direction: column;
  }

  .features-section .col {
    max-width: 100%;
  }

  .features-section .card-title {
    font-size: 1.1rem;
  }

  .features-section .card-text {
    font-size: 0.85rem;
  }

  .feature-img {
    width: 80px;
    height: 80px;
    margin: 10px auto;
  }

  .contact-section {
    min-height: 100vh;
    padding: 40px 20px;
  }

  .contact-section h2 {
    font-size: 1.8rem;
  }

  .contact-section .col {
    max-width: 100%;
  }

  .contact-section .form-label-custom {
    width: auto;
    text-align: left;
    margin-right: 0;
    margin-bottom: 5px;
  }

  .contact-section .form-group {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-section .form-control {
    font-size: 0.9rem;
  }

  .contact-section .btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  .hero-section h1.display-4 {
    font-size: 1.8rem;
  }

  .hero-section .lead {
    font-size: 0.9rem;
  }

  .hero-section p {
    font-size: 0.8rem;
  }

  .features-section h2 {
    font-size: 1.6rem;
  }

  .features-section .card-title {
    font-size: 1rem;
  }

  .features-section .card-text {
    font-size: 0.8rem;
  }

  .feature-img {
    width: 60px;
    height: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,mBAAmB;AACnB;EACE,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,uDAAuD;EACvD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* src/styles/App.css */\n\n/* Global Stiller */\nbody {\n  margin: 0;\n  font-family: 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/* Mevcut Stiller */\n.App {\n  text-align: center;\n}\n\n/* Navbar Logo */\n.navbar-brand .logo {\n  height: 40px;\n  width: auto;\n  margin-right: 10px;\n}\n\n/* Navbar */\n.navbar {\n  padding: 10px 20px;\n}\n\n/* Navbar Dil Değişim Butonu */\n.navbar .nav-link.language-toggle {\n  font-weight: bold;\n  color: #00c4ff !important;\n}\n\n.navbar .nav-link.language-toggle:hover {\n  color: #ffffff !important;\n}\n\n/* Hero Section */\n.hero-section {\n  min-height: 100vh;\n  background: linear-gradient(to right, #007bff, #00c4ff);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.hero-section h1.display-4 {\n  font-weight: bold;\n  font-size: 2.5rem;\n}\n\n.hero-section .lead {\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n}\n\n.hero-section p {\n  font-size: 1rem;\n}\n\n/* Features Section */\n.features-section {\n  min-height: 100vh;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.features-section h2 {\n  font-size: 2rem;\n  margin-bottom: 30px;\n}\n\n.features-section .feature-card {\n  border: none;\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease-in-out;\n}\n\n.features-section .feature-card:hover {\n  transform: translateY(-5px);\n}\n\n.features-section .card-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.features-section .card-text {\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.feature-img {\n  width: 100px;\n  height: 100px;\n  object-fit: contain;\n  margin: 15px auto;\n  display: block;\n}\n\n/* Contact Section */\n.contact-section {\n  min-height: 100vh;\n  background-color: #f8f9fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: left;\n}\n\n.contact-section h2 {\n  font-size: 2rem;\n  margin-bottom: 30px;\n}\n\n/* Form Etiketlerini Sağa Hizala */\n.form-label-custom {\n  width: 100px;\n  text-align: right;\n  margin-right: 15px;\n}\n\n.contact-section .form-group {\n  display: flex;\n  align-items: center;\n}\n\n.contact-section .form-group textarea {\n  align-self: flex-start;\n}\n\n/* Footer */\nfooter {\n  background-color: #1a1a1a;\n  color: white;\n  padding: 30px 20px;\n}\n\nfooter p {\n  margin: 5px 0;\n  font-size: 0.9rem;\n}\n\nfooter a {\n  color: #00c4ff;\n  text-decoration: none;\n}\n\nfooter a:hover {\n  text-decoration: underline;\n}\n\n/* Mobil Uyumluluk için Media Queries */\n@media (max-width: 768px) {\n  .hero-section h1.display-4 {\n    font-size: 2rem;\n  }\n\n  .hero-section .lead {\n    font-size: 1rem;\n  }\n\n  .hero-section p {\n    font-size: 0.9rem;\n  }\n\n  .hero-section .btn {\n    font-size: 0.9rem;\n    padding: 8px 16px;\n  }\n\n  .features-section {\n    min-height: 100vh;\n    padding: 40px 20px;\n  }\n\n  .features-section h2 {\n    font-size: 1.8rem;\n  }\n\n  .features-section .row {\n    flex-direction: column;\n  }\n\n  .features-section .col {\n    max-width: 100%;\n  }\n\n  .features-section .card-title {\n    font-size: 1.1rem;\n  }\n\n  .features-section .card-text {\n    font-size: 0.85rem;\n  }\n\n  .feature-img {\n    width: 80px;\n    height: 80px;\n    margin: 10px auto;\n  }\n\n  .contact-section {\n    min-height: 100vh;\n    padding: 40px 20px;\n  }\n\n  .contact-section h2 {\n    font-size: 1.8rem;\n  }\n\n  .contact-section .col {\n    max-width: 100%;\n  }\n\n  .contact-section .form-label-custom {\n    width: auto;\n    text-align: left;\n    margin-right: 0;\n    margin-bottom: 5px;\n  }\n\n  .contact-section .form-group {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .contact-section .form-control {\n    font-size: 0.9rem;\n  }\n\n  .contact-section .btn {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .hero-section h1.display-4 {\n    font-size: 1.8rem;\n  }\n\n  .hero-section .lead {\n    font-size: 0.9rem;\n  }\n\n  .hero-section p {\n    font-size: 0.8rem;\n  }\n\n  .features-section h2 {\n    font-size: 1.6rem;\n  }\n\n  .features-section .card-title {\n    font-size: 1rem;\n  }\n\n  .features-section .card-text {\n    font-size: 0.8rem;\n  }\n\n  .feature-img {\n    width: 60px;\n    height: 60px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
